/* eslint-disable no-restricted-syntax */
const ONE_MINUTE_MS = 60_000
const ONE_HOUR_MS = ONE_MINUTE_MS * 60
const ONE_DAY_MS = ONE_HOUR_MS * 24

export function msAgo(ms: number) {
  return new Date(Date.now() - ms)
}

export function msFromNow(ms: number) {
  return new Date(Date.now() + ms)
}

export function minutesAgo(minutes: number) {
  return new Date(Date.now() - minutes * ONE_MINUTE_MS)
}

export function minutesFromNow(minutes: number) {
  return new Date(Date.now() + minutes * ONE_MINUTE_MS)
}

export function hoursAgo(hours: number) {
  return new Date(Date.now() - hours * ONE_HOUR_MS)
}

export function hoursFromNow(hours: number) {
  return new Date(Date.now() + hours * ONE_HOUR_MS)
}

export function daysAgo(days: number) {
  return new Date(Date.now() - days * ONE_DAY_MS)
}

export function daysFromNow(days: number) {
  return new Date(Date.now() + days * ONE_DAY_MS)
}

export function monthsFromNow(months: number) {
  const d = new Date()
  d.setMonth(d.getMonth() + months)
  return d
}

export function yearsAgo(years: number) {
  const d = new Date()
  d.setFullYear(d.getFullYear() - years)
  return d
}

export function yearsFromNow(years: number) {
  const d = new Date()
  d.setFullYear(d.getFullYear() + years)
  return d
}
